export const isBeforeSale = () => {
    const today = new Date().getTime();
    // const to = new Date("2021-11-19T20:00:00-0700").getTime();
    const to = new Date().getTime();

    let isBeforeTheSale;

    if (today < to) {
        isBeforeTheSale = true;
    } else {
        isBeforeTheSale = false;
    }


    return isBeforeTheSale;

}
